var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("Link", { attrs: { href: "/" } }, [
    _c("img", {
      staticStyle: { "max-width": "300px" },
      attrs: { src: "/musicologie-wordmark.webp" },
    }),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }